export function formatTabNotificationCount(count) {
  const n = Number(count) || 0;
  if (n <= 0) return null;
  return n > 99 ? "99+" : String(n);
}

export function buildDashboardTabNotificationsPath({ dashboard, tabKey, moduleName } = {}) {
  const params = new URLSearchParams({ status: "unread" });
  if (moduleName) params.set("module", moduleName);
  if (tabKey && tabKey !== "overview") {
    if (dashboard === "buyer") params.set("buyerTab", tabKey);
    else if (dashboard === "seller") params.set("sellerTab", tabKey);
    else if (dashboard === "qa") params.set("qaTab", tabKey);
    else if (dashboard === "logistics") params.set("logisticsTab", tabKey);
  }
  return `/dashboard/notifications?${params.toString()}`;
}
